/* Sazón House — standard product page: gallery, options, quantity, real add to cart (theme cart drawer), sticky bar, related products, reveals. */
(() => {
  const root = document.querySelector('[data-sdsp]');
  if (!root) return;
  root.classList.add('is-js');
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const stacked = matchMedia('(max-width: 989px)');
  const pad = n => String(n).padStart(2, '0');
  let variants = [];
  try { variants = JSON.parse($('[data-variants]').textContent); } catch (e) {}

  /* ---------- gallery ---------- */
  const track = $('[data-track]'), slides = $$('[data-slide]'), thumbs = $$('[data-go]'), cur = $('[data-cur]'), strip = $('.sdsp-thumbs');
  let at = 0, prevTimer = null;
  const mark = i => {
    if (i === at || !slides[i]) return;
    slides.forEach((s, k) => { s.classList.toggle('is-prev', k === at); s.classList.toggle('is-on', k === i); });
    clearTimeout(prevTimer);
    prevTimer = setTimeout(() => slides.forEach(s => s.classList.remove('is-prev')), 550);
    thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
    if (cur) cur.textContent = pad(i + 1);
    at = i;
    const t = thumbs[i];
    if (t && strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: still ? 'auto' : 'smooth' });
  };
  const go = i => {
    if (!slides[i]) return;
    mark(i);
    if (stacked.matches) track.scrollTo({ left: i * track.clientWidth, behavior: still ? 'auto' : 'smooth' });
  };
  thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.go)));
  if (track) {
    let raf;
    track.addEventListener('scroll', () => {
      if (!stacked.matches) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => mark(Math.round(track.scrollLeft / track.clientWidth)));
    }, { passive: true });
    stacked.addEventListener('change', () => { track.scrollLeft = stacked.matches ? at * track.clientWidth : 0; });
  }

  /* ---------- options ---------- */
  const idField = $('[data-id]'), groups = $$('[data-opt]');
  const addBtns = $$('[data-add]'), stock = $('[data-stock]');
  const chosen = () => { const v = variants.find(x => String(x.id) === String(idField.value)); return v ? v.options.slice() : []; };
  const setVariant = (v, showPhoto, keepUrl) => {
    if (!v) return;
    idField.value = v.id;
    $$('[data-price]').forEach(x => { x.textContent = v.price; });
    const cmp = $('[data-compare]');
    if (cmp) { cmp.hidden = !v.compare; if (v.compare) cmp.textContent = v.compare; }
    $$('[data-vname]').forEach(x => { x.textContent = v.title; });
    groups.forEach(g => {
      const k = +g.dataset.opt;
      $('[data-optname]', g).textContent = v.options[k];
      $$('[data-value]', g).forEach(p => {
        const on = p.dataset.value === v.options[k];
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-checked', on);
        const want = v.options.slice(); want[k] = p.dataset.value;
        const match = variants.find(x => x.options.every((o, j) => o === want[j]));
        p.classList.toggle('is-off', !match || !match.available);
      });
    });
    addBtns.forEach(b => { b.disabled = !v.available; $('[data-addt]', b).textContent = v.available ? 'Add to cart' : 'Sold out'; });
    if (stock) { stock.classList.toggle('is-out', !v.available); $('[data-stockt]', stock).textContent = v.available ? 'In stock' : 'Sold out'; }
    const dimg = $('[data-dimg]');
    if (dimg && v.thumb) dimg.src = v.thumb;
    if (showPhoto && v.image !== null) go(v.image);
    if (!keepUrl) try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
  };
  groups.forEach(g => $$('[data-value]', g).forEach(p => p.addEventListener('click', () => {
    const want = chosen(); want[+g.dataset.opt] = p.dataset.value;
    // exact combination first; if it does not exist, the first variant that has the value just chosen
    const v = variants.find(x => x.options.every((o, j) => o === want[j])) || variants.find(x => x.options[+g.dataset.opt] === p.dataset.value);
    setVariant(v, true);
  })));
  if (groups.length && variants.length) {
    const start = variants.find(x => String(x.id) === String(idField.value));
    const asked = new URLSearchParams(location.search).has('variant');
    setVariant(start, asked, true); // the gallery opens on the first photo unless the link asks for a specific option
  }

  /* ---------- quantity ---------- */
  const qty = $('[data-qty]');
  $$('[data-q]').forEach(b => b.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + +b.dataset.q); }));
  if (qty) qty.addEventListener('change', () => { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

  /* ---------- add to cart: real Ajax cart, shown in the theme's cart drawer ---------- */
  const form = $('form.sdsp-form'), errorBox = $('[data-error]');
  let adding = false;
  if (form) form.addEventListener('submit', async e => {
    e.preventDefault();
    if (adding) return;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const routes = window.routes || {};
    const body = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(s => s.id));
      body.append('sections_url', location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    adding = true;
    if (errorBox) errorBox.hidden = true;
    addBtns.forEach(b => b.setAttribute('aria-busy', 'true'));
    try {
      const res = await fetch(routes.cart_add_url || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const data = await res.json();
      if (data.status) { if (errorBox) { errorBox.textContent = data.description || data.message || 'This item could not be added to your cart.'; errorBox.hidden = false; } return; }
      if (!cart || typeof cart.renderContents !== 'function') { location.href = routes.cart_url || '/cart'; return; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(idField.value), cartData: data });
      cart.classList.remove('is-empty');
      cart.renderContents(data);
      addBtns.forEach(b => { b.classList.add('is-done'); $('[data-addt]', b).textContent = 'Added to cart'; });
      setTimeout(() => addBtns.forEach(b => { b.classList.remove('is-done'); $('[data-addt]', b).textContent = b.disabled ? 'Sold out' : 'Add to cart'; }), 1800);
    } catch (err) {
      if (errorBox) { errorBox.textContent = 'This item could not be added to your cart. Please try again.'; errorBox.hidden = false; }
    } finally {
      adding = false;
      addBtns.forEach(b => b.removeAttribute('aria-busy'));
    }
  });

  /* ---------- sticky bar: only after the main button has scrolled away, never over the footer ---------- */
  const dock = $('[data-dock]'), atc = $('[data-atc]'), foot = document.querySelector('.sdsh-foot');
  if (dock && atc) {
    const dockBtn = $('[data-add]', dock);
    const sync = () => {
      const footTop = foot ? foot.getBoundingClientRect().top : Infinity;
      const on = atc.getBoundingClientRect().bottom < 0 && footTop > innerHeight * (stacked.matches ? 1.2 : .92);
      dock.classList.toggle('is-on', on);
      dock.setAttribute('aria-hidden', !on);
      if (dockBtn) dockBtn.tabIndex = on ? 0 : -1;
    };
    addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    sync();
  }

  /* ---------- related products (Shopify recommendations) ---------- */
  const rel = $('[data-rel]');
  if (rel && root.dataset.recs) {
    fetch(root.dataset.recs).then(r => r.text()).then(html => {
      const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sdsp-recs]');
      if (!box || !box.children.length) return;
      $('[data-rel-grid]', rel).innerHTML = box.innerHTML;
      rel.hidden = false;
    }).catch(() => {});
  }

  /* ---------- subtle scroll reveals ---------- */
  if (!still && 'IntersectionObserver' in window) {
    root.classList.add('js-rv');
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('[data-rv]').forEach((el, k) => { el.style.transitionDelay = (k % 4) * 60 + 'ms'; io.observe(el); });
  }
})();
